import { Link, linkToRecord, Loading, useGetList, useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { ISession, ISpeaker } from '../../types';
import { getSessionsForSpeaker } from './utils';

interface IProps {
  asChip?: boolean;
  source?: string;
}

export const ConfsForSpeaker = (props: IProps) => {
  const { data, isLoading, error } = useGetList<ISession>('sessions', { pagination: { page: 1, perPage: 10000 } });
  const record = useRecordContext<ISpeaker>();
  if (isLoading) {
    return <Loading />;
  }
  if (error) {
    return <p>ERROR</p>;
  }

  if (!record) {
    return null;
  }
  const sessions = data ? getSessionsForSpeaker(record.id, Object.values(data)) : [];

  // without this, the 'list' also process the event and we are redirected to Edit-speaker, no Edit-session
  const stopProp = (e: any) => e.stopPropagation();

  return props.asChip ? (
    <span>
      {sessions.map((sess: ISession) => {
        const sessPage = linkToRecord('/sessions', sess.id, 'show');
        return (
          <Link to={sessPage} key={sess.id}>
            <Chip label={sess.title.substring(0, 10)} clickable={true} onClick={stopProp} />
          </Link>
        );
      })}
    </span>
  ) : (
    <div style={{ backgroundColor: 'lightgray', borderRadius: '15px', padding: '5px' }}>
      Sesiones en las que participa:
      <ul style={{ textAlign: 'left' }}>
        {sessions.map((sess: ISession) => {
          const sessPage = linkToRecord('/sessions', sess.id, 'show');
          return (
            <li key={sess.id}>
              <Link to={sessPage}>{sess.title}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
